import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import Role from "../Roles";
// import { TextContainer } from "../../pages/AvaNegarLanding/index.styled";
import {
  EnamadContainer,
  FooterAddress,
  FooterAddressItem,
  FooterButtom,
  FooterContainer,
  FooterContent,
  FooterNav,
  FooterWrapper,
  LogoContainer,
  TextContainer,
} from "./index.styled";

const Footer = () => {
  const footerItem = [
    { id: 1, content: "آوانگار چیست", path: "aboutAvanegar" },
    { id: 2, content: "ویژگی‌ها", path: "features" },
    { id: 3, content: "کاربردها", path: "usages" },
    { id: 4, content: "قوانین و مقررات", path: "roles" },
  ];
  // const xmas = new Date("December 25, 2000 23:15:00");
  // const year = xmas.getYear();
  // console.log(year);
  return (
    <FooterContainer className="container">
      <LogoContainer>
        <h2>آوانــگـــار</h2>
      </LogoContainer>
      <FooterWrapper>
        <FooterContent>
          {/* <LogoContainer>
            <h2>آوانــگـــار</h2>
          </LogoContainer> */}
          <TextContainer
            color="#424243"
            className="footer-contnet"
            width="586px"
            height="190px"
          >
            <p>
              هوش مصنوعی روزبه‌روز خدمات متنوعی را در اختیار ما قرار می‌دهد و
              نیازهای گوناگون ما در هر حوزه‌ای به کمک این فناوری در حال برآورده
              شدن است. سرویس تبدیل صوت به متن فارسی از آن دسته خدماتی است که با
              استفاده از فناوری هوش مصنوعی برای بهبود رابط کاربری و ایجاد سهولت
              بیشتر برای فارسی زبانان توسعه داده شده و به صورت یک API قابل ادغام
              با نرم‌افزارها و اپلیکیشن‌هاست.
            </p>
          </TextContainer>
        </FooterContent>

        <FooterNav>
          {footerItem.map((item) => (
            <li key={item.id}>
              {item.id === 4 ? (
                <Link to="/roles">{item.content}</Link>
              ) : (
                <a href={`#${item.path}`}>{item.content}</a>
              )}
            </li>
          ))}
        </FooterNav>
        <FooterAddress>
          <FooterAddressItem width="342px" height="64px">
            <p>
              تهران، میدان کاج، خیابان سرو شرقی، خیابان مجد کوچه نسترن، پلاک ۳۴
            </p>
          </FooterAddressItem>
          <FooterAddressItem width="342px" height="32px">
            <p>شماره پشتیبانی : ۷۴۳۱۸۸۳۵ - ۰۲۱</p>
          </FooterAddressItem>
          <FooterAddressItem width="342px" height="32px">
            <p>شماره فروش : ۷۴۳۱۸۰۵۰ - ۰۲۱</p>
          </FooterAddressItem>
          <FooterAddressItem width="342px" height="32px">
            <span>ایمیل فروش: </span>
            <a href="mailto:market@partdp.ir">market@partdp.ir</a>
          </FooterAddressItem>
          <EnamadContainer>
            <a
              // referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=270942&amp;Code=tsBXc81vmdWikQ7xk1hF"
            >
              <img
                // referrerpolicy="origin"
                src="https://Trustseal.eNamad.ir/logo.aspx?id=270942&amp;Code=tsBXc81vmdWikQ7xk1hF"
                alt="enamad"
                id="tsBXc81vmdWikQ7xk1hF"
                style={{ width: "100px", height: "100px" }}
              />
            </a>
          </EnamadContainer>
        </FooterAddress>
      </FooterWrapper>
      <FooterButtom>
        <div>
          تمامی حقوق و محتوا برای{" "}
          <a href="https://partdp.ai/fa/" target="_blank" rel="noreferrer">
            مرکز تحقیقات هوش مصنوعی پارت
          </a>{" "}
          محفوظ است. ۱۴۰۲
        </div>
      </FooterButtom>
    </FooterContainer>
  );
};

export default Footer;
